import { SofaSelectItem } from '@sofology/sofologycomponents';

import { OptionDescription, PropertyDescription, PropertyDescriptionTypes } from 'models';
import { PropertyValueType } from './formHelperAdditionalData';


export const nullableValueToString = (value: PropertyValueType): string =>
    (value === null ? '' : value.toString());

export const getOptionsForSofaInput = (propertyOptions: OptionDescription[]): SofaSelectItem[] => {
    return propertyOptions.map(x => {
        return {
            title: x.label,
            value: x.value
        } as SofaSelectItem;
    });
};

export function createPropertiesMap(properties: Record<string, PropertyDescriptionTypes>): Record<string, PropertyDescriptionTypes> {
    const propertiesMap = {};

    for (const propertyKey in properties) {
        const property = properties[propertyKey];

        if (property.name) {
            propertiesMap[property.name] = property;
        }

        if (property.properties) {
            propertiesMap[property.name] = property;
            for (const subPropertyKey in property.properties) {
                const subProperty = property.properties[subPropertyKey];
                propertiesMap[subProperty.name] = subProperty;
            }
        }
    }

    return propertiesMap;
}

export function getDefaultValueByProperty(propertyDescription: PropertyDescription): string | boolean | null {
    if (propertyDescription.type === 'number') {
        return null;
    }

    if (propertyDescription.type === 'boolean') {
        return false;
    }

    return '';
}